import React from "react";
import { FilterPanel, Input } from "@aidkitorg/component-library";
import { ReportFilterConfig } from "@aidkitorg/types/lib/admin-panel/filters";
import { useLocalizedStrings } from "../../../Localization";
import { useSettingsFilterFields } from "../../Filters/hooks/useSettingsFilterFields";
import { useFieldValueSuggestions } from "../../shared/hooks/useFieldValueSuggestions";

export type ApplicantCountFormFieldsProps = {
  title: string;
  setTitle: (val: string) => void;
  filterConfig?: ReportFilterConfig;
  setFilterConfig: (val: ReportFilterConfig | undefined) => void;
  isEditMode?: boolean;
};

export const ApplicantCountFormFields: React.FC<ApplicantCountFormFieldsProps> = ({
  title,
  setTitle,
  filterConfig,
  setFilterConfig,
  isEditMode = false,
}) => {
  const L = useLocalizedStrings()
  const availableFieldsForFilters = useSettingsFilterFields();
  const { fetchSuggestions } = useFieldValueSuggestions();

  return (
    <>
      <div className="p-4 bg-gray-50 rounded-lg">
        <div className="text-sm text-gray-600">
          {L.admin_panel.dashboards.applicant_count_desc}
        </div>
      </div>

      <Input
        label={L.admin_panel.dashboards.metric_title}
        required
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {L.admin_panel.dashboards.filters_label}
        </label>
        <FilterPanel
          value={filterConfig}
          onChange={setFilterConfig}
          availableFields={availableFieldsForFilters}
          instanceId="applicant-count-form-filters"
          fetchFieldValues={fetchSuggestions}
          inline
        />
      </div>
    </>
  );
};